__turbopack_context__.v({
  "style": "Parallax-module__O_ZRBW__style",
});
